/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Air_Handler_Unit_DescriptionInputs */



/**
* | output |
* | --- |
* | "See temperature, humidity and CO₂ on the AHU diagram, schedule its operating hours and make the most of free cooling." |
*
* @param {Go_Further_Air_Handler_Unit_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_air_handler_unit_description = /** @type {((inputs?: Go_Further_Air_Handler_Unit_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Air_Handler_Unit_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("See temperature, humidity and CO₂ on the AHU diagram, schedule its operating hours and make the most of free cooling.")
	return /** @type {LocalizedString} */ ("Visualisez températures, humidité et CO₂ sur le schéma de la CTA, programmez ses plages de fonctionnement et profitez du free cooling.")
});